import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Plus, MapPin, Users, Edit2, Trash2, ToggleLeft, ToggleRight } from 'lucide-react';
import { StatusBadge } from './components/StatusBadge';
import { LocationModal } from './components/LocationModal';
import { useAdminData } from '../contexts/AdminDataContext';
export function AdminLocations() {
  const {
    locations,
    saveLocation,
    deleteLocation,
    toggleLocationActive
  } = useAdminData();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState<any>(null);
  const handleEdit = (location: any) => {
    setSelectedLocation(location);
    setIsModalOpen(true);
  };
  const handleNew = () => {
    setSelectedLocation(null);
    setIsModalOpen(true);
  };
  const handleSave = (data: any) => {
    if (selectedLocation) {
      saveLocation({
        ...selectedLocation,
        ...data
      });
    } else {
      saveLocation(data);
    }
    setIsModalOpen(false);
  };
  const handleDelete = (id: string) => {
    deleteLocation(id);
  };
  const handleToggleActive = (id: string) => {
    toggleLocationActive(id);
  };
  return <div className="space-y-6" data-id="element-422">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-423">
        <div data-id="element-424">
          <h1 className="font-display text-3xl font-bold text-earth mb-2" data-id="element-425">
            Ubicaciones
          </h1>
          <p className="text-stone" data-id="element-426">
            Administra los espacios donde impartes tus clases.
          </p>
        </div>
        <button onClick={handleNew} className="flex items-center gap-2 bg-sage text-white px-5 py-2.5 rounded-xl font-semibold hover:bg-sage/90 transition-colors shadow-sm" data-id="element-427">
          <Plus size={18} data-id="element-428" />
          Nueva Ubicación
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-429">
        {locations.map((location, index) => <motion.div key={location.id} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.1
      }} className={`bg-white rounded-2xl border ${location.is_active ? 'border-mist' : 'border-mist/50 opacity-75'} shadow-sm overflow-hidden flex flex-col`} data-id="element-430">
            <div className="p-6 flex-1" data-id="element-431">
              <div className="flex justify-between items-start mb-4" data-id="element-432">
                <div className="w-12 h-12 bg-sand rounded-xl flex items-center justify-center text-sage" data-id="element-433">
                  <MapPin size={24} data-id="element-434" />
                </div>
                <StatusBadge status={location.type} data-id="element-435" />
              </div>

              <h3 className="font-display text-xl font-bold text-earth mb-2" data-id="element-436">
                {location.name}
              </h3>
              <p className="text-stone text-sm mb-4" data-id="element-437">
                {location.address}
                {location.city ? `, ${location.city}` : ''}
              </p>

              <div className="flex items-center gap-2 text-sm text-stone font-medium" data-id="element-438">
                <Users size={16} className="text-sage" data-id="element-439" />
                Capacidad: {location.capacity} personas
              </div>
            </div>

            <div className="p-4 border-t border-mist bg-sand/10 flex justify-between items-center" data-id="element-440">
              <button onClick={() => handleToggleActive(location.id)} className={`flex items-center gap-2 text-sm font-bold uppercase tracking-wider transition-colors ${location.is_active ? 'text-success hover:text-success/70' : 'text-stone hover:text-stone/70'}`} title={location.is_active ? 'Desactivar ubicación' : 'Activar ubicación'} data-id="element-441">
                {location.is_active ? <ToggleRight size={24} data-id="element-442" /> : <ToggleLeft size={24} data-id="element-443" />}
                {location.is_active ? 'Activa' : 'Inactiva'}
              </button>
              <div className="flex items-center gap-2" data-id="element-444">
                <button onClick={() => handleDelete(location.id)} className="flex items-center gap-1 text-sm font-semibold text-stone hover:text-error transition-colors" title="Eliminar" data-id="element-445">
                  <Trash2 size={16} data-id="element-446" />
                </button>
                <button onClick={() => handleEdit(location)} className="flex items-center gap-2 text-sm font-semibold text-earth hover:text-sage transition-colors" data-id="element-447">
                  <Edit2 size={16} data-id="element-448" />
                  Editar
                </button>
              </div>
            </div>
          </motion.div>)}
      </div>

      <LocationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={handleSave} location={selectedLocation} data-id="element-449" />
    </div>;
}